import React from "react";
import TopHeader from "./TopHeader";
import NavigationBar from "./NavigationBar";

const Header = () => {
  return (
    <>
      <TopHeader />
      <NavigationBar />
    </>
  );
};

export default Header;